/**
 * Shared pricing primitives for the /pricing page and the upgrade dialog.
 *
 * Extracted from the original ``PricingCardV2`` inside PricingV2Section.
 * Both surfaces (public pricing page + professional-tier upgrade dialog)
 * now compose from these primitives so the visual language stays in one
 * place.
 *
 * Each primitive is presentation-only — auth, router, Stripe, VAT math
 * all live in the consumer.
 */

// Only exports currently consumed by callers. If a future consumer needs
// ``PlanPriceDisplay`` / ``PlanPriceDisplayProps`` directly, re-add them in
// the same PR that uses them — keeps knip's unused-code check honest.
export { PlanCard } from './PlanCard';
// ``PlanFeatureList`` is re-exported for the standalone Profil+ compact row
// (ProfessionalPricingSection) — the first external consumer that needs it
// directly rather than through PlanCard/TrialCtaSection.
// ``CheckmarkVariant`` is still consumed by PricingV2Section via the barrel.
export { PlanFeatureList } from './PlanFeatureList';
export type { CheckmarkVariant } from './PlanFeatureList';
// ``formatAmount`` is re-exported for the same compact Profil+ row, which
// needs the rounding rule without pulling in PlanPriceDisplay's large 4xl
// price styling.
export { formatAmount } from './PlanPriceDisplay';
export { TrialCtaSection } from './TrialCtaSection';
